import { object, func } from "prop-types";
import validate from "../validate";

const Validate = ({ constraints, userInput, children }) => {
  const validation = validate(userInput, constraints) || {};
  const isValid = Object.keys(validation).length === 0;
  return children({ isValid, validation });
};

Validate.propTypes = {
  constraints: object.isRequired,
  userInput: object,
  children: func.isRequired,
};

export default Validate;
